<div class="modal-title-section d-flex align-items-center" mat-dialog-title>
    <span *ngIf="(iconUrl$ | async) as iconUrl"
      class="section-icon d-flex justify-content-center align-items-center mr-10px"
      [inlineSVG]="iconUrl">
    </span>
    <span>{{(modalTitle$ | async) | translate | appFirstLetterUppercase}}</span>
</div>
